module.exports = __webpack_public_path__ + "static/img/join.61d2a18.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/BrandGfei/join.png
// module id = 1129
// module chunks = 18